export default __webpack_public_path__ + "static/media/SellectedDropDown.4270d38e.svg";